(() => {
  const owned = new Map();
  const configurations = [
    ['.fwSwiper', () => ({ loop: true, slidesPerView: 1, autoplay: { delay: 5000, disableOnInteraction: false } })],
    ['.mySwiper', () => cards(1.5, 5)],
    ['.mySwiper-collection', () => cards(1.5, 3)],
    ['.mySwiper-brands', () => cards(1.5, 5)],
    ['.marshydro-led-column', () => ({ ...cards(1.3, 4.5), breakpoints: {768:{slidesPerView:2},1024:{slidesPerView:4},1300:{slidesPerView:4.5}} })],
    ['.mySwiper-grow-comp', () => cards(1.5, 4)],
    ['.mySwiper-mobile', () => ({ ...cards(1, 1.5), breakpoints: {768:{slidesPerView:1.5},1024:{slidesPerView:1.5},1300:{slidesPerView:1.5}} })],
    ['.compare-grid', () => ({slidesPerView:2,spaceBetween:0,breakpoints:{768:{enabled:false}}})],
    ['.tag-swiper', () => ({slidesPerView:'auto',spaceBetween:16,freeMode:true,grabCursor:true}), 768],
    ['.tag-swiper-bottom', () => ({slidesPerView:'auto',spaceBetween:12,freeMode:true,grabCursor:true,loop:false,breakpoints:{768:{spaceBetween:16}}})],
    ['.icon-bar-swiper', () => ({slidesPerView:1,spaceBetween:20,loop:true}), 767]
  ];
  function cards(first,desktop) {
    return {slidesPerView:first,spaceBetween:20,loop:false,breakpoints:{768:{slidesPerView:2},1024:{slidesPerView:3},1300:{slidesPerView:desktop}}};
  }
  function initialize(root = document) {
    if (typeof window.Swiper === 'function') {
      configurations.forEach(([selector, options, maximumWidth]) => {
        const nodes = [...root.querySelectorAll(selector)];
        if (root.matches?.(selector)) nodes.unshift(root);
        nodes.forEach(element => {
          const previous = owned.get(element);
          if (maximumWidth && innerWidth > maximumWidth) {
            if (previous) { previous.destroy(true, true); owned.delete(element); }
            return;
          }
          if (element.swiper && !element.swiper.destroyed) return;
          const controls = element.closest('.shopify-section') || element;
          const local = selector => element.querySelector(selector) || controls.querySelector(selector);
          const config = options();
          const pagination = local('.swiper-pagination');
          const next = local('.swiper-button-next');
          const prev = local('.swiper-button-prev');
          if (pagination) config.pagination = {el:pagination,clickable:true};
          if (next || prev) config.navigation = {nextEl:next,prevEl:prev};
          owned.set(element, new window.Swiper(element, config));
        });
      });
    }
    const jq = window.jQuery;
    if (!jq) return;
    root.querySelectorAll('ul.tabs').forEach(list => {
      if (list.dataset.sgTabsReady) return;
      list.dataset.sgTabsReady = 'true';
      const links = [...list.querySelectorAll('a')];
      const panel = link => {
        const href = link?.getAttribute('href');
        return href?.startsWith('#') && href.length > 1 ? document.getElementById(href.slice(1)) : null;
      };
      let active = links.find(link => panel(link));
      if (!active) return;
      links.forEach(link => { link.classList.toggle('active',link===active); const content=panel(link); if(content) { content.classList.toggle('active',link===active); content.style.display=link===active?'':'none'; } });
      list.addEventListener('click', event => {
        const link=event.target.closest('a'); const content=panel(link);
        if (!link || !list.contains(link) || !content) return;
        event.preventDefault(); active.classList.remove('active');
        const previous=panel(active); if(previous) { previous.classList.remove('active'); previous.style.display='none'; }
        active=link; active.classList.add('active'); content.classList.add('active'); content.style.display='';
        owned.forEach(swiper => { if(content.contains(swiper.el)) swiper.update(); });
      });
    });
    if (jq.fn.accordion) {
      const fresh=[...root.querySelectorAll('.faq')].filter(element=>!element.dataset.sgAccordionReady);
      fresh.forEach(element=>element.dataset.sgAccordionReady='true');
      if (fresh.length) jq(fresh).accordion({defaultOpen:'',cookieName:'accordion_nav'});
    }
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    owned.forEach((swiper,element)=>{if(event.target.contains(element)){swiper.destroy(true,true);owned.delete(element);}});
  });
  let frame;
  window.addEventListener('resize',()=>{if(frame)return;frame=requestAnimationFrame(()=>{frame=0;initialize();});},{passive:true});
})();
